import bodyClasses from './body-classes';
import $ from 'jquery';

$(_ => {

    const $logoMain = $('#logo-main');

    if ($logoMain.length === 0) return;

    let scrollY = 0;
    let handling = false;

    const $body = $(document.body);

    let isShort = false;

    const classShort = bodyClasses.header.short;
    const classTransitioning = bodyClasses.header.transitioning;

    function updateBodyClass() {
        let transition = null;
        if (scrollY <= 100 && isShort) {
            transition = function() {
                $body.removeClass(classShort);
                isShort = false;
            };
        } else if (scrollY > 100 && isShort === false) {
            transition = function() {
                $body.addClass(classShort);
                isShort = true;
            };
        }

        if (transition) {
            window.requestAnimationFrame(_ => {
                $body.addClass(classTransitioning);
                transition();
                handling = false;
            });
        } else {
            handling = false;
        }
    }

    function onTransitionEnd() {
        window.requestAnimationFrame(_ => {
            $body.removeClass(classTransitioning);
        });
    }

    window.addEventListener('scroll', _ => {
        scrollY = window.scrollY;
        if (handling === false) {
            window.requestAnimationFrame(updateBodyClass);
        }
        handling = true;
    });

    $logoMain.on('transitionend', _ => {
        window.requestAnimationFrame(onTransitionEnd);
    });

});